import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {
    CheckboxSkeleton,
    FormItemSkeleton,
    FormSectionSkeleton,
    InputSkeleton,
    RadioButtonSkeleton,
    SkeletonItem,
} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';


export const MSDynamicsSectionSkeleton = () => (
    <Group direction="v" alignItems="start" gap="l">
        <FormSectionSkeleton labelWidth={113}>
            <FormItemSkeleton labelWidth={129}>
                <Item className="pt-s">
                    <Group gap="l" alignItems="center">
                        <RadioButtonSkeleton labelWidth={57}/>
                        <RadioButtonSkeleton labelWidth={37}/>
                        <CheckboxSkeleton labelWidth={76}/>
                    </Group>
                </Item>
            </FormItemSkeleton>
            <ResponsiveElementGroup>
                <FormItemSkeleton labelWidth={55}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={83}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={95}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
            </ResponsiveElementGroup>
        </FormSectionSkeleton>
        <FormSectionSkeleton labelWidth={110}>
            <ResponsiveElementGroup>
                <FormItemSkeleton labelWidth={76}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={106}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
            </ResponsiveElementGroup>
        </FormSectionSkeleton>
        <FormItemSkeleton labelWidth={74}>
            <Group direction="v" alignItems="start">
                <CheckboxSkeleton labelWidth={77}/>
                <Table borderedGrid={true}>
                    <Head>
                        <Cell/>
                        <Cell className="text-align_center"><SkeletonItem width={80} height={16}/></Cell>
                        <Cell className="text-align_center"><SkeletonItem width={80} height={16}/></Cell>
                        <Cell className="text-align_center"><SkeletonItem width={80} height={16}/></Cell>
                        <Cell className="text-align_center"><SkeletonItem width={80} height={16}/></Cell>
                    </Head>
                    <Body>
                        <Row>
                            <Cell><SkeletonItem width={80} height={16}/></Cell>
                            <Cell className="text-align_center"><SkeletonItem width={20} height={16}/></Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                        </Row>
                        <Row>
                            <Cell><SkeletonItem width={50} height={16}/></Cell>
                            <Cell className="text-align_center"><SkeletonItem width={20} height={16}/></Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                        </Row>
                        <Row>
                            <Cell><SkeletonItem width={60} height={16}/></Cell>
                            <Cell className="text-align_center"><SkeletonItem width={20} height={16}/></Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                            <Cell>
                                <Group justify="center">
                                    <CheckboxSkeleton/>
                                </Group>
                            </Cell>
                            <Cell/>
                        </Row>
                    </Body>
                </Table>
            </Group>
        </FormItemSkeleton>
    </Group>
);
